import React from "react";
import * as accessrightservice from "../services/access-rights-service";
import * as userservice from "../../../services/user/user-service";
import "./access-rights.css";
import { Authorize } from "../../../components/authorize";
import Auth from "../../../utils/auth";
import * as Loader from "../../../common/common";
let userRole;

export default class AccessRights extends Authorize {
  constructor(props) {
    super(props);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onSaveAccessRights = this.onSaveAccessRights.bind(this);
    this.state = {
      users: "",
      entitlements: "",
      userName: "",
      label: "",
      message: "",
    };

    userRole = Auth.get("role");
  }

  async componentDidMount() {
    Loader.showLoader();
    let accessRightResp = await accessrightservice.getKycAccessRightsEntitlements();
    let response = await userservice.getActiveUsers();
    Loader.hideLoader();
    this.setState({
      users: response?.response?.data || [],
      entitlements: accessRightResp?.accessRightResp?.data || [],
    });
  }

  handleCheck(id, e) {
    const target = e.target;
    const value = target.checked;

    let rights = Object.assign([], this.state.entitlements);
    let userEntitlements = rights.map((r) => {
      if (r.Id === id) {
        r.Value = value;
      }
      return r;
    });

    this.setState({
      entitlements: userEntitlements,
    });
  }

  async getUserAccessRights(userId) {
    Loader.showLoader();
    let { response, err } = await accessrightservice.getAccessRightsById(
      userId
    );
    Loader.hideLoader();
    if (err) {
      this.setState({
        message: "Error: " + err,
      });
    } else if (response && response.data.err) {
      this.setState({
        message: "Error: " + response.data.err,
      });
    } else {
      if (response.data.length > 0) {
        let getEntitlements = [];
        for (let i = 0; i < response.data.length; i++) {
          getEntitlements = this.state.entitlements.map((e) => {
            if (
              response.data[i].entitlement === e.Entitlement &&
              response.data[i].functionality === e.Functionality
            ) {
              e.Value = true;
            }
            return e;
          });
        }

        this.setState({
          entitlements: getEntitlements,
        });
      } else {
        let entitlementsCopy = Object.assign([], this.state.entitlements);
        let entitlements = entitlementsCopy.map((e) => {
          e.Value = false;
          return e;
        });
        this.setState({
          entitlements: entitlements,
        });
      }
    }
  }

  handleInputChange(e) {
    let userName = e.target.value;
    const selectedUser = this.state.users.find(
      (u) => u.companyName === userName
    );

    if (!userName || !selectedUser) {
      let entitlementsCopy = Object.assign([], this.state.entitlements);
      let entitlements = entitlementsCopy.map((e) => {
        e.Value = false;
        return e;
      });
      this.setState({
        entitlements: entitlements,
        userName: userName,
        label: "",
      });
      return;
    }

    const userId = selectedUser.userId;
    this.getUserAccessRights(userId);
    this.setState({
      userName: userName,
      label: "",
    });
  }

  async onSaveAccessRights(e) {
    e.preventDefault();
    const selectedUser = this.state.users.find(u => u.companyName === this.state.userName);
    const userId = selectedUser ? selectedUser.userId : null;

    let userEntitlements = this.state.entitlements.filter((e) => {
      return e.Value === true;
    });

    let userAccessRights = {
      userId: userId,
      entitlements: userEntitlements,
    };
    Loader.showLoader();
    let { response, err } = await accessrightservice.saveUserAccessRights(
      userAccessRights
    );
    Loader.hideLoader();
    if (err) {
      this.setState({
        message: "Error: " + err,
      });
    } else if (response && response.data.err) {
      this.setState({
        message: "Error: " + response.data.err,
      });
    } else {
      let entitlementsCopy = Object.assign([], this.state.entitlements);
      let entitlements = entitlementsCopy.map((e) => {
        e.Value = false;
        return e;
      });
      this.setState({
        label: response.data.msg,
        userName: "",
        entitlements: entitlements,
      });
    }
  }

  render() {
    const authorizationResult = super.render();
    if (authorizationResult) {
      return authorizationResult;
    }

    let { entitlements } = this.state;

    let entitlementObject = {};
    let tableHeaderObject = {};
    if (entitlements.length > 0) {
      for (let i = 0; i < entitlements.length; i++) {
        if (entitlementObject[entitlements[i].Functionality]) {
          entitlementObject[entitlements[i].Functionality].push(
            entitlements[i]
          );
        } else {
          entitlementObject[entitlements[i].Functionality] = [entitlements[i]];
        }

        if (tableHeaderObject[entitlements[i].Entitlement]) {
          tableHeaderObject[entitlements[i].Entitlement].push(entitlements[i]);
        } else {
          tableHeaderObject[entitlements[i].Entitlement] = [entitlements[i]];
        }
      }
    }

    var keys = Object.keys(entitlementObject);
    var tableHeaders = Object.keys(tableHeaderObject);
    var a = {};
    let tableHeader = [];
    for (let i = 0; i < tableHeaders.length; i++) {
      if (Object.keys(a).indexOf(tableHeaders[i]) === -1) {
        a[tableHeaders[i]] = [];

        tableHeader.push(<th key={tableHeaders[i]}>{tableHeaders[i]}</th>);
      }
    }

    let checkBoxes = keys.map((k, index) => {
      var arrOfIndx = [];
      for (var n = 0; n < entitlementObject[k].length; n++) {
        arrOfIndx.push(
          Object.keys(a).indexOf(entitlementObject[k][n].Entitlement)
        );
      }

      for (var l = 0; l < Object.keys(a).length; l++) {
        if (arrOfIndx.indexOf(l) === -1) {
          let obj = {
            Id: +new Date() + l,
            Functionality: k,
            Entitlement: "",
            Value: false,
          };

          entitlementObject[k].splice(l, 0, obj);
        }
      }

      let values = entitlementObject[k].map((b, indx) => {
        if (Object.keys(a)[indx] === b.Entitlement) {
          return (
            <td className="text-center" key={b.Id}>
              <input
                type="checkbox"
                placeholder=" "
                onChange={this.handleCheck.bind(this, b.Id)}
                checked={b.Value}
              />
            </td>
          );
        } else {
          return <td key={b.Id}></td>;
        }
      });

      return (
        <tr key={k}>
          <td>{k}</td>
          {values}
        </tr>
      );
    });

    let Users = [];
    if (this.state.users != null && this.state.users.length > 0) {
      for (let u of this.state.users) {
        if (u.email !== Auth.get("email") && u.userType === "InternalUser") {
          Users.push(
            <option key={u.userId} value={u.companyName}>
              {u.companyName}
            </option>
          );
        }
      }
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <form onSubmit={this.onSaveAccessRights}>
              <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-sm-4 mr-5">
                  <label htmlFor="Assigned Users" style={{ fontSize: "small" }}>
                    Select A User :{" "}
                  </label>
                  <input
                    type="text"
                    value={this.state.userName}
                    list="assignedUsers"
                    onChange={this.handleInputChange}
                    name="userName"
                    className="form-control"
                    autoComplete="off"
                    placeholder="Select User"
                  />
                  <datalist id="assignedUsers">{Users}</datalist>
                </div>
              </div>
              <br />
              <div className="table-responsive">
                <table className="access-rights table   table-condensed table-hovered table-bordered">
                  <thead>
                    <tr>
                      <th>Functionality</th>
                      {tableHeader}
                    </tr>
                  </thead>
                  <tbody>{checkBoxes}</tbody>
                </table>
              </div>

              <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-sm-2 float-right">
                  {userRole !== "04" ? (
                    <input
                      type="submit"
                      className="btn btn-primary btn-block"
                      value="Save"
                      disabled={
                        this.state.userName && userRole !== "04" ? false : true
                      }
                    />
                  ) : null}
                </div>
                <span style={{ color: "green" }}>{this.state.label}</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
